<template>
    <div class="call-history">   
      <span class="has-text-size-20 has-text-weight-bold">
        Belhistorie van {{client.title}} {{client.name}}
      </span>
      <span class="is-pulled-right"><i class="fal fa-history fa-3x has-text-grey-light"></i></span>
      <br>
      <div v-if="calls" class="pt-4 my2">
          <div v-for="call in limitedCalls"
              :key="call.id"
              class="mb-1">
              <p class="has-text-weight-bold has-text-size-12">
                  {{ call.pretty_date }}
                  <span>&nbsp; &#183; &nbsp;</span>
                  {{ callMinutes(call) }} min.
                  <span v-if="call.volunteer_id == myId">&nbsp; &#183; &nbsp; Dit gesprek {{ lang('heb/heeft') }} {{ lang('je/u') }} zelf gevoerd</span>
              </p>
              <p v-if="call.callComment" class="mb-2 italic has-text-size-14">
                  {{ call.callComment.comment }}
              </p>
          </div>
        <p v-if="limitedCount - limitedCalls.length">
          Nog {{ limitedCount - limitedCalls.length }} eerdere gesprekken
          <br>
          <button class="mt-2 button is-secondary is-uppercase" :class='{"is-loading": loading}' @click="$emit('load-more')">
            Meer laden
          </button>
        </p>
        <p v-if="!limitedCalls.length && !loading">
          <i>Nog geen eerdere gesprekken gevonden, je bent de eerste!</i>
          </p>
      </div>
    </div>      
</template>

<script>
  import { Client } from '../../../models/Client';

  export default {
    props: {
      calls: {
        type: [Array, Boolean],
        required: true
      },
      client: {
        type: Client,
        required: true
      },
      limit: {
        type: Number,
        default: 10
      },
      myId: {
        type: Number
      },
      loading: true,
      count: null
    },
    computed: {
      limitedCalls () {
        return this.calls.slice(0, this.limit);
      },
      limitedCount () {
        return Math.min(this.count, this.limit);
      }
    },
    methods: {
      callMinutes (call) {
        return Math.round(call.duration / 60);
      }
    }
  };
</script>
